import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

export var Wrapper = /*#__PURE__*/_styled("div", true ? {
  target: "e1xuwow0"
} : {
  target: "e1xuwow0",
  label: "Wrapper"
})(true ? {
  name: "1sk9ltb",
  styles: "padding-bottom:32px;overflow:hidden"
} : {
  name: "1sk9ltb",
  styles: "padding-bottom:32px;overflow:hidden",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvbWF0Y2hhL3JlY2lwZXMvQWNjb3JkaW9uL0NvbnRlbnRXcmFwcGVyL0NvbnRlbnRXcmFwcGVyLnZpZXdzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVpQyIsImZpbGUiOiIvd29ya2Rpci9saWJzL21hdGNoYS9yZWNpcGVzL0FjY29yZGlvbi9Db250ZW50V3JhcHBlci9Db250ZW50V3JhcHBlci52aWV3cy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG5leHBvcnQgY29uc3QgV3JhcHBlciA9IHN0eWxlZC5kaXZgXG4gIHBhZGRpbmctYm90dG9tOiAzMnB4O1xuICAvLyBUaGlzIGlzIGhhY2sgZm9yIGp1bXBpbmcgY29udGVudCBmcm9tIFJpY2hUZXh0LlxuICBvdmVyZmxvdzogaGlkZGVuO1xuYFxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});